/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    byId: {},
    allIds: [],
}

const ServicesSlice = createAppSlice({
    name: 'supervision/services',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        create: create.asyncThunk(
            async (service, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.service.all(), { body: service, method: 'POST' })
                    toast.success('Service créé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'un service')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        update: create.asyncThunk(
            async (service, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.service.all(), { body: service, method: 'PUT' })
                    toast.success('Service modifié avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification d\'un service')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        delete: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.service.single(id), { method: 'DELETE' })
                    toast.success('Service supprimé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'un service')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        fetch: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.service.all())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des services')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    const byId = keyBy(action.payload, 'id')
                    state.byId = byId
                    state.allIds = action.payload.map(service => service.id)
                },
                options: {
                    condition: (_, { getState }) => {
                        const { supervision } = getState()
                        return supervision.services.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            }
        ),
    }),
    selectors: {
        selectServices: (state) => state.allIds.map(id => state.byId[id]),
    },
})

export const ServicesActions = ServicesSlice.actions
export const {
    selectServices,
} = ServicesSlice.getSelectors((state) => state.supervision.services)
export default ServicesSlice